import { FeatureItem } from '@/components/FeatureItem/FeatureItem';
import { useAmelioTranslations } from '@/hooks';

const SelectEvaluatorsHeader = () => {
    const { t } = useAmelioTranslations();

    return (
        <FeatureItem
            className={'max-w-120 px-10 py-8'}
            heading={t('cycleEvaluationSelectEvaluators.header.featureItem.heading')}
            description={t('cycleEvaluationSelectEvaluators.header.featureItem.description')}
            icon={'users-profile-tick'}
            dataTestId={'select-evaluators-header'}
        />
    );
};

export { SelectEvaluatorsHeader };
